module.exports = __webpack_public_path__ + "img/filter.b8209a24.svg";